import { apiFetch } from '$lib/api/helpers';
import type { InputDeviceRequest, InputDeviceResponse } from '$lib/types/input_device';

const PATH = '/input_devices/';

export async function fetchInputDevices(unitId?: number) {
  const endpoint = unitId ? `${PATH}?unit=${unitId}` : PATH;
  return apiFetch<Array<InputDeviceResponse>>(endpoint);
}

export async function createInputDevice(request: InputDeviceRequest) {
  return apiFetch<InputDeviceResponse>(PATH, {
    method: 'POST',
    body: JSON.stringify(request)
  });
}

export async function updateInputDevice(id: number, data: Partial<InputDeviceRequest>) {
  return apiFetch<InputDeviceResponse>(`${PATH}${id}/`, {
    method: 'PATCH',
    body: JSON.stringify(data)
  });
}

export async function deleteInputDevice(id: number) {
  return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function copyInputDeviceProgramming(targetId: number, sourceDeviceId: number) {
  return apiFetch<InputDeviceResponse>(`${PATH}${targetId}/copy_programming/`, {
    method: 'POST',
    body: JSON.stringify({ source_device_id: sourceDeviceId })
  });
}
